import schema, { generateType } from './Schema';
export const ItemProgress = generateType(schema.getModel('itemProgress'))
    .actions(() => ({}))
    .views(() => ({}));
//# sourceMappingURL=ReportsModel.js.map